var render = function render(){var _vm=this,_c=_vm._self._c;return _c('public-form-layout',{attrs:{"title":_vm.title}},[_c('document',{attrs:{"src":_vm.src,"height":"40vh","param":_vm.param}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }